import {useNavigate} from "react-router-dom";
import {Stack, Box, Typography, Card, CardContent, useTheme} from "@mui/material";
import LandingBanner from "../../assets/images/landing-banner.png";
import SecurityIcon from "@mui/icons-material/Security";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SettingsIcon from '@mui/icons-material/Settings';
import BarChartIcon from '@mui/icons-material/BarChart';
import CustomButton from "../components/ui/CustomButton";
import CustomTypography from "../components/ui/CustomTypography";
import EastIcon from "@mui/icons-material/East";
import useWidth from "../utils/useWidth";


const LandingScreen = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const breakpoints = useWidth();

  const features = [
    {
      icon: <SecurityIcon fontSize="large" color="primary" />,
      title: 'Enhanced Security',
      description: 'Robust access control with real-time verification and authorization.',
    },
    {
      icon: <AccessTimeIcon fontSize="large" color="primary" />,
      title: 'Time Efficient',
      description: 'Reduce wait times with automated check-in and verification processes.',
    },
    {
      icon: <SettingsIcon fontSize="large" color="primary" />,
      title: 'Easy Management',
      description: 'Comprehensive dashboard for monitoring all gate activities.',
    },
    {
      icon: <BarChartIcon fontSize="large" color="primary" />,
      title: 'Analytics & Reports',
      description: 'Gain insights with detailed analytics and customizable reports.',
    },
  ]
  
  const handleLogin = () => {
    navigate("/login");
  }


  return (
    <>
      <Box 
        sx={{
          position: 'relative', width: (breakpoints === "xs" || breakpoints === "sm") ? "95%" : "98%", height: '500px', overflow: 'hidden', display: 'flex', alignItems: 'center',
          justifyContent: 'center', textAlign: 'center', color: 'white', fontFamily: 'sans-serif', margin: "auto", mt: (breakpoints === "xs" || breakpoints === "sm") ? 1 : 3 
        }}
      >
        <Box alt="" src={LandingBanner} component="img"
          sx={{
            position: "absolute", zIndex: 1, filter: "brightness(0.6)",
            top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover",
          }}
        />

        <Box
          sx={{
            position: "absolute", top: 0, left: 0, width: "100%", opacity: 0.45, 
            height: "100%", zIndex: 2,
            backgroundColor: "#00255c", inset: 0
            // backgroundColor: "#0d5a7b",
          }}
        />

        <Box sx={{position: "relative", zIndex: 3}}>
          <CustomTypography 
            variant="h2"
            text={"Smart Gate Access Management"}
            customStyles={{
              marginBottom: 0, 
              color: "#fff", 
              fontWeight: 700,
              fontSize: (breakpoints === "md") ? "55px" : (breakpoints === "xs" || breakpoints === "sm") ? "40px" : {}
            }}
          />

          <CustomTypography 
            variant="subtitle1" 
            text={"Streamlined entry and exit solutions for businesses, residents, and visitors"}
            customStyles={{color: "#fff", fontSize: (breakpoints === "xs" || breakpoints === "sm") ? 15 : 18}}
          />
       
          <CustomButton   
            variant="contained" 
            label="Get Started"
            endIcon={<EastIcon fontSize="small" />}
            customStyles={{
              fontSize: 16,
              backgroundColor: "#fff",
              fontWeight: 500, 
              color: theme.palette.primary.main,
              mt: (breakpoints === "xs" || breakpoints === "sm") ? 2 : 4, p: "12px 20px",
            }}
            onClick={handleLogin}         
          />
        </Box>
      </Box>

      <Box
        sx={{
          py: 5, background: "linear-gradient(to bottom, #f4f9ff, #ffffff)",
          textAlign: 'center',
        }}
      >
        <CustomTypography 
          variant="h3"
          text={"Why Choose GatePass"}
          customStyles={{
            marginBottom: 1, 
            color: theme.palette.primary.main,
            fontWeight: 700,
            fontSize: (breakpoints === "xs" || breakpoints === "sm") ? 22 : {}
          }}
        />

        <CustomTypography 
          variant="subtitle1" 
          text={"Our comprehensive solution streamlines gate access management with powerful features and intuitive design."}
          customStyles={{
            color: theme.typography.secondary
          }}
        />

        <Stack
          direction={{xs: "column", sm: "row"}}
          spacing={{xs: 2, sm: 3, md: 4}}
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
          sx={{mt: 4.5}}
        >
          {features?.map((feature, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                maxWidth: "280px",
                flexGrow: 1,
                mt: (breakpoints === "md" && index === 3) ? "26px !important" : {}
              }}
            >
              <Card
                sx={{
                  py: 3,
                  px: 2,
                  width: "100%",
                  minHeight: "240px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  border: `1px solid #e5edf6`,
                  boxShadow:
                    "0px 2px 1px -1px #0066ff30, 0px 1px 1px 0px #0066ff30, 0px 1px 30px 0px #0066ff30",
                  transition: "box-shadow 0.3s ease, transform 0.3s ease",
                  '&:hover': {
                    transform: 'translateY(-2px)',
                  },
                }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  {feature.icon}

                  <Typography variant="subtitle1" fontWeight="bold" mt={2}>
                    {feature.title}
                  </Typography>

                  <Typography
                    variant="body2"
                    mt={1}
                    sx={{ color: theme.typography.secondary, fontWeight: 400 }}
                  >
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Box>
          ))}
        </Stack>
      </Box>

      <Box sx={{py: 3, textAlign: "center", backgroundColor:  "#F0F9FF"}}>
        <Typography variant="caption" color="text.secondary">
          © 2025 Subic Bay Metropolitan Authority. All rights reserved.
        </Typography>
      </Box>
    </>
  )
}

export default LandingScreen